/**
 * Erstellt einen Initial-Cache für alle Filteroptionen.
 *
 * Optionen, die global über alle Items hinweg nie vorkommen,
 * werden als permanent unmöglich markiert.
 */
export function buildInitialOptionState(filters, items, tokenCache) {
    const state = new Map();

    filters.forEach((filter) => {
        const key = filter.dataset.filter;
        if (key === "sortierung") return;

        filter.querySelectorAll("input[type='checkbox']").forEach((input) => {
            const initialCount = items.reduce((acc, item) => {
                const tokens = tokenCache.get(item);
                const set = tokens?.[key];
                return set && set.has(input.value) ? acc + 1 : acc;
            }, 0);

            state.set(input, {
                initialCount,
                permanentlyDisabled: initialCount === 0,
            });
        });
    });

    return state;
}

/**
 * Aktualisiert für jede Filteroption sowohl die Trefferanzahl als auch den
 * disabled-Zustand auf Basis der aktuell aktiven Filter.
 *
 * Verhalten:
 * - innerhalb derselben Filtergruppe gilt ODER
 * - zwischen verschiedenen Filtergruppen gilt UND
 * - bereits ausgewählte Optionen bleiben immer aktiv, damit sie abgewählt werden können
 * - Optionen mit initialCount === 0 bleiben dauerhaft disabled
 */
export function updateOptionCounts(filters, items, active, tokenCache, initialOptionState) {
    filters.forEach((filter) => {
        const key = filter.dataset.filter;
        if (key === "sortierung") return;

        filter.querySelectorAll("input[type='checkbox']").forEach((input) => {
            const label = input.closest("label");
            const countEl = label ? label.querySelector(".option-count") : null;

            const initialState = initialOptionState.get(input);

            // Global unmögliche Optionen bleiben dauerhaft disabled und auf 0.
            if (initialState?.permanentlyDisabled) {
                if (countEl) {
                    countEl.textContent = "(0)";
                }
                input.checked = false;
                input.disabled = true;
                return;
            }

            const test = cloneActive(active);
            const current = test[key] || [];
            test[key] = current.includes(input.value) ? current : [...current, input.value];

            const count = items.reduce((acc, item) => {
                const tokens = tokenCache.get(item);
                if (!tokens) return acc;

                return matchesAllFilters(tokens, test) ? acc + 1 : acc;
            }, 0);

            if (countEl) {
                countEl.textContent = `(${count})`;
            }

            input.disabled = !input.checked && count === 0;
        });
    });
}

function cloneActive(active) {
    return Object.fromEntries(
        Object.entries(active).map(([key, values]) => [key, [...values]])
    );
}

function matchesAllFilters(tokens, active) {
    const keys = Object.keys(active).filter((key) => key !== "sortierung");

    return keys.every((key) => {
        const set = tokens[key];
        if (!set || set.size === 0) return false;
        return active[key].some((value) => set.has(value));
    });
}